export default __webpack_public_path__ + "static/media/202080.6fd24152.jpg";